import { render, staticRenderFns } from "./leave-information.vue?vue&type=template&id=319f84e1&scoped=true&"
import script from "./leave-information.vue?vue&type=script&lang=ts&"
export * from "./leave-information.vue?vue&type=script&lang=ts&"
import style0 from "./leave-information.vue?vue&type=style&index=0&id=319f84e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f84e1",
  null
  
)

export default component.exports